import clsx from "clsx";
import { IconProps } from "@/types/icons";
import { createColorClasses } from "@/theme/colors";

export const ShareLink = ({
  width = 24,
  height = 24,
  className,
  color = "primary",
  decorative = false,
  ariaLabel = "Share link",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      viewBox="0 0 24 24"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path
        fill="#06C"
        fillRule="evenodd"
        d="M15.5 16a2.5 2.5 0 1 1-.5 1.5 1.3 1.3 0 0 1 .1-.6l-7.6-3.4a2.5 2.5 0 1 1 0-3l7.6-3.4a1.3 1.3 0 0 1-.1-.6 2.5 2.5 0 1 1 .5 1.5l-7.6 3.4c.08.19.115.395.1.6a1.3 1.3 0 0 1-.1.6zM19 6.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0m-13.5 7a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m10.5 4a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};
